import { Component, Injector } from '@angular/core';
import { DateTimeService } from '../shared/services/datetime.service';
import { AppComponentBase } from './app-component-base';
import { AppVersion } from './shared/app-version';
import { AppConsts } from './../shared/AppConsts';

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent extends AppComponentBase {
    version = '';

    constructor(injector: Injector, public dateTimeService: DateTimeService) {
        super(injector);

        if (AppConsts.versionDisplayMode === 'commit') {
            this.version = AppVersion.Version;
        } else {
            this.version = dateTimeService.getDateTimeToDisplayFromMilliseconds(
                Number.parseInt(this.browserStorageService.get('version'), 10)
            );
        }
    }

    getVersionText(): string {
        if (AppConsts.versionDisplayMode === 'commit') {
            return this.l('Version', this.version);
        } else {
            return this.l('LastUpdate', this.version);
        }
    }
}
